<template>
  <div class="personalCenter">
    <headers></headers>
    <div class="contentBox">
      <div class="infoCard">
        <div class="avatar">
<!--          <img v-if="userInfo.user.headPortraitUrl" :src="userInfo.user.headPortraitUrl" alt="">-->
          <img src="./imgs/avatar.png" alt="">
        </div>
        <div class="infoContent">
          <div class="infoBox">
            <div class="title">{{userInfo.user.userName}}</div>
            <div class="email">{{userInfo.user.email}}</div>
            <div class="loginOut">
              <van-button type="primary" @click="loginOut">退出登录</van-button>
            </div>
          </div>
        </div>
      </div>
      <div class="myCase">
        <h3 class="title">我的案件</h3>
        <div class="caseContent">
          <van-empty v-if="totalRows === 0" description="暂无数据" />
          <van-pull-refresh v-else v-model="refreshing" success-text="刷新成功" @refresh="onRefresh" animation-duration="500">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
              <div class="caseList">
                <div class="caseItem" v-for="(item, index) in caseList" @click="goCaseDetail(item)">
                  <div class="caseTop">
                    <div class="caseTitle">登记时间：{{item.createTime}}</div>
                    <div class="caseLabel">{{item.statusName}}</div>
                  </div>
                  <div class="caseBody">
                    <div class="caseInfo">
                      <p class="caseMan">申请人：{{item.apply}}</p>
                      <p class="caseMan">被申请人：{{item.respondent}}</p>
                    </div>
                    <div class="arrow">
                      <i class="iconfont icon-gengduo"></i>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
      <div class="caseBottom">
        <p class="tips">若您需上传证据或查看调解进度，请移步PC端官网查看</p>
        <p class="tips">官网地址：https://adr.ccpit.org/</p>
      </div>
    </div>
  </div>
</template>

<script>
import headers from "@/components/header";
import { setStore, getStore, removeStore } from '@/utils/utils';
import { getCaseList } from '@/api/user';
import config from '@/config/config';
export default {
  name: 'personalCenter',
  data() {
    return {
      totalRows: 1,
      loading: false,
      finished: false,
      refreshing: false,
      caseList: [],
      param: {
        title: '', // 搜索关键词
        roleCode: '', // 角色code
        orgId: '', // 机构id，除普通用户外都需必填
        statusCode: 'ALL', // 状态码
        pageIndex: 0,
        pageSize: 5,
      },
      userInfo: {
        user: {
          headPortraitUrl: '',
        },
      },
      pcLink: '',
    };
  },
  components: {
    headers,
  },
  watch: {
  },
  mounted() {
    this.pcLink = config.PCURL;
    if (getStore('userInfo')) {
      this.userInfo = JSON.parse(getStore('userInfo'));
      this.userInfo.user.headPortraitUrl = config.baseURL + this.userInfo.user.headPortraitUrl;
      const loginRoleInfo = JSON.parse(getStore('loginRole'));
      this.param.orgId = this.userInfo.orgId;
      this.param.roleCode = loginRoleInfo.roleCode;
      // this.getCaseList();
    }
  },
  methods: {
    loginOut() {
      removeStore('loginRole');
      removeStore('menus');
      removeStore('token');
      removeStore('userInfo');
      this.$toast('退出成功！');
      setTimeout(() => {
        window.location.href = '/';
      }, 500);
    },
    onLoad() {
      const self = this;
      if (self.loading && !self.finished) {
        self.param.pageIndex = self.param.pageIndex + 1;
        self.getCaseList();
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = false;
      this.param.pageIndex = 1;
      this.caseList = [];
      this.getCaseList();
    },
    getCaseList() {
      const self = this;
      self.refreshing = true;
      // 增加loading
      self.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      getCaseList(self.param).then((res) => {
        self.$toast.clear();
        self.refreshing = false;
        if (res.data.code = 200) {
          self.caseList = self.caseList.concat(res.data.result.list);
          self.loading = false;
          self.totalRows = res.data.result.count;
          // 是否还有下一页
          if (res.data.result.pageNum < res.data.result.pageCount) {
            self.finished = false;
          } else {
            self.finished = true;
          }
        } else {
          self.$toast(res.data.message);
        }
      });
    },
    goCaseDetail(item) {
      setStore('caseId', item.id);
      this.$router.push({ path: '/caseDetail', query: { id: item.id } });
    },
  },
  updated() {
  },
};
</script>

<style scoped lang="scss">
.personalCenter{
  width: 100%;
  height: 100%;
  background: #F6F6F6;
  .contentBox {
    width: calc(100% - 30px);
    height: calc(100% - 70px);
    padding: 10px 15px;
    .infoCard {
      width: 100%;
      height: 155px;
      overflow: hidden;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-image: url('./imgs/centerBg.png');
      display: flex;
      justify-content: left;
      .avatar {
        width: 140px;
        height: 91%;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 88px;
          height: 88px;
        }
      }
      .infoContent {
        height: 91%;
        display: flex;
        justify-content: center;
        align-items: center;
        .infoBox {
          .title {
            font-size: 17px;
            font-weight: bold;
            color: #333333;
            line-height: 30px;
          }
          .email {
            line-height: 35px;
            font-size: 13px;
            color: #333333;
            font-weight: 500;
          }
          .loginOut {
            .van-button {
              height: 30px;
              width: 100px;
              font-size: 13px;
              background: linear-gradient(90deg, #3790FF, #376BFF);
              box-shadow: 0px 10px 7px 0px rgba(102, 174, 228, 0.18);
              border-radius: 15px;
              border: none;
              line-height: 30px;
            }
          }
        }
      }
    }
    .myCase {
      width: 100%;
      height: calc(100% - 215px);
      padding-top: 10px;
      padding-bottom: 5px;
      position: relative;
      .title {
        line-height: 21px;
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        margin: 0;
      }
      .caseContent {
        margin-top: 10px;
        width: 100%;
        height: calc(100% - 40px);
        overflow-y: scroll;
        .caseList {
          padding-top: 5px;
          .caseItem {
            padding: 15px 8px 10px 0;
            background: #FFFFFF;
            box-shadow: 0px 4px 16px 0px rgba(233, 233, 233, 0.8);
            border-radius: 8px;
            margin-bottom: 12px;
            .caseTop {
              display: flex;
              justify-content: space-between;
              .caseTitle {
                height: 30px;
                font-size: 15px;
                font-weight: 500;
                color: #333333;
                line-height: 30px;
                padding-left: 15px;
                position: relative;
              }
              .caseTitle:before {
                content: "";
                position: absolute;
                left: 0;
                top: 6px;
                height: 18px;
                width: 3px;
                background-color: #376bff;
              }
              .caseLabel {
                background: #ebf0ff;
                border-radius: 14px;
                font-size: 12px;
                font-weight: 500;
                color: #376BFF;
                line-height: 26px;
                padding: 2px 15px 0 15px;
              }
            }
            .caseBody {
              padding-left: 15px;
              display: flex;
              justify-content: space-between;
              .caseInfo {
                .caseMan {
                  font-size: 14px;
                  font-weight: 500;
                  color: #999999;
                  line-height: 20px;
                }
              }
              .arrow {
                display: flex;
                align-items: center;
                .icon-gengduo {
                  font-size: 16px;
                  font-weight: 500;
                  color: #999999;
                  line-height: 20px;
                }
              }
            }
          }
        }
        ::v-deep .van-list__finished-text {
          line-height: 30px;
        }
      }
    }
    .caseBottom {
      width: 100%;
      .tips {
        font-size: 12px;
        font-weight: 500;
        color: #999999;
        line-height: 21px;
        text-align: center;
      }
    }
  }
}
</style>
